import { parseDigits } from '@/utils';

export const formatZipCode = (value: string) => {
  const numericValue = parseDigits(value);
  const len = numericValue.length;

  if (len > 5) {
    return `${numericValue.slice(0, 5)}-${numericValue.slice(5, 8)}`;
  }

  return numericValue;
};
